import React, { useMemo } from "react"

import ActivityBase from "@/components/activities/base"
import Changes from "@/components/activities/changes"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"

interface UpdatedProps {
  activity: any
  className?: string
}

const Updated = ({ activity, className }: UpdatedProps) => {
  const LABELS = {
    // Fields
    name: i18n.t("app.activities.venue.field_labels.name"),
    country: i18n.t("app.activities.venue.field_labels.country"),
    timezone: i18n.t("app.activities.venue.field_labels.timezone"),
    // Info
    address: i18n.t("app.activities.venue.field_labels.address"),
    city: i18n.t("app.activities.venue.field_labels.city"),
    description: i18n.t("app.activities.venue.field_labels.description"),
    email: i18n.t("app.activities.venue.field_labels.email"),
    facilities: i18n.t("app.activities.venue.field_labels.facilities"),
    phone: i18n.t("app.activities.venue.field_labels.phone"),
    socialAccounts: i18n.t("app.activities.venue.field_labels.social_accounts"),
    venueType: i18n.t("app.activities.venue.field_labels.venue_type"),
    website: i18n.t("app.activities.venue.field_labels.website"),
    zipcode: i18n.t("app.activities.venue.field_labels.zipcode"),
    // Logo
    logo: i18n.t("app.activities.venue.field_labels.logo"),
  }

  const formatters = useMemo(() => {
    return {
      facilities: (value) => {
        if (value == null) return ""
        return Array.isArray(value) ? value.join(", ") : String(value)
      },
      socialAccounts: (value) => {
        if (value == null) return i18n.t("app.common.none")
        if (typeof value === "object" && !Array.isArray(value)) {
          const entries = Object.entries(value).filter(([, v]) => v)
          return entries.length > 0
            ? entries
                .map(([k, v]) => {
                  const display = typeof v === "object" ? JSON.stringify(v) : String(v as string)
                  return `${k}: ${display}`
                })
                .join(", ")
            : i18n.t("app.common.none")
        }
        return String(value)
      },
      venueType: (value) => {
        if (value == null) return ""
        return Array.isArray(value) ? value.join(", ") : String(value)
      },
      logo: (value) => value || i18n.t("app.activities.venue.field_labels.logo_removed"),
    }
  }, [])

  return (
    <ActivityBase
      data-testid="panel-activity-venue-updated"
      activityKey={activity.key}
      createdAt={activity.createdAt}
      text={
        <>
          {i18n.react("app.activities.venue.updated.description", {
            owner: <OwnerLabel owner={activity.owner} />,
          })}
          <Changes changes={activity.parameters.changes} labels={LABELS} formatters={formatters} />
        </>
      }
      className={className}
    />
  )
}

export default Updated
